/* eslint-disable no-unsafe-optional-chaining */
import { InMemoryCache } from '@apollo/client'
import buildPossibleTypes from './possible-types'

const possibleTypes = buildPossibleTypes()

const cache = new InMemoryCache({
  possibleTypes,
  typePolicies: {
    OrganizationType: {
      fields: {
        logo: {
          merge: true,
        },
      },
    },

    Query: {
      fields: {
        projectsConnections: {
          keyArgs: ['types'],
          merge(_existing, incoming) {
            const mergedProjects = new Set([...(incoming.projects || [])])

            return {
              __typename: incoming.__typename,
              pageInfo: incoming.pageInfo,
              projects: Array.from(mergedProjects),
              maxCashValue: incoming.maxCashValue,
            }
          },
        },

        firstActiveTemplateMilestones: {
          merge: false,
        },

        noteableNotes: {
          merge: false,
        },

        projectTaskNotes: {
          merge: false,
        },

        noteablePaginatedNotes: {
          merge: false,
        },

        notificationConnections: {
          keyArgs: ['types'],
          merge(existing, incoming, { readField }) {
            const seenIds = new Set<string>()
            const notifications: typeof incoming.notifications = []

            for (const notification of [
              ...(existing?.notifications || []),
              ...(incoming?.notifications || []),
            ]) {
              const id = readField<string>('id', notification)
              if (id && !seenIds.has(id)) {
                seenIds.add(id)
                notifications.push(notification)
              }
            }

            return {
              __typename: incoming.__typename,
              pageInfo: incoming.pageInfo,
              notifications,
            }
          },
        },
      },
    },

    UserType: {
      fields: {
        avatar: {
          merge: true,
        },
      },
    },

    TaskUtilizationType: {
      merge: true,
    },

    ProjectType: {
      fields: {
        profitabilitySummary: {
          merge: true,
        },
      },
    },

    MilestoneType: {
      fields: {
        summaryBank: {
          merge: false,
        },
      },
    },

    TemplateType: {
      fields: {
        milestones: {
          merge: false,
        },
        dependentTasks: {
          merge: false,
        },

        summaryBank: {
          merge(existing = {}, incoming = {}) {
            return {
              ...existing,
              ...incoming,
            }
          },
        },
      },
    },

    Subscription: {
      fields: {
        projectUpdated: {
          keyArgs: ['types'],
          // istanbul ignore next
          merge(existing = {}, incoming) {
            const project = {
              ...(existing.project || {}),
              ...(incoming.project || {}),
            }

            const stats = {
              ...(existing.projectStats || {}),
              ...(incoming.projectStatus || {}),
            }

            return {
              project,
              projectStats: stats,
            }
          },
        },
      },
    },

    // we have a number of subscriptions for project updates
    // but not all of them are setup correctly. This makes sure
    // we're not corrupting the cache with partial payloads
    ProjectUpdatePayloadType: {
      fields: {
        // istanbul ignore next
        projectStats(existing = {}, incoming) {
          if (!incoming) return existing

          return {
            ...existing,
            ...incoming,
          }
        },
      },
    },
  },
})

export default cache
